import jsonLogic from "json-logic-js";
export default function(){
    this.main.cap = function cap(cb){
        this.rule.required = this.isRequiredIf();
        if(this.active() && this.validates()){
            if(this.rule.required) this.required();
            if(this.rule.required && this.value === undefined){
                return cb();
            }
            if(this.rule.rule && typeof this.rule.rule === "object"){
                if(!jsonLogic.apply(this.rule.rule, this.source)){
                    this.raise("il campo %s non è valido");
                    return cb();
                }
            }
            this.pattern();
            this.range();
        }
        cb();
    };
};
